import { Component, Input, OnInit, Output } from '@angular/core';
import { Observable, of, Subject } from 'rxjs';
import { catchError, take } from 'rxjs/operators';
import { PermissionsEnum } from 'src/app/enums/permissions.enum';
import { Id } from 'src/app/models/database/types/id.model';
import { PepService } from 'src/app/services/http/pep/pep.service';
import { PermissionService } from 'src/app/services/http/permission/permission.service';
import { SnackbarService } from 'src/app/services/utils/snackbar/snackbar.service';

@Component({
  selector: 'app-delete-datasheet-section',
  templateUrl: './delete-datasheet-section.component.html',
  styleUrls: ['./delete-datasheet-section.component.scss']
})
export class DeleteDatasheetSectionComponent {

  @Input() sessionId: Id
  @Output() sessionDeleted: Subject<void> = new Subject<void>()
  verifyUserPermission$: Observable<boolean> = this._permissionService.verify(PermissionsEnum.EDIT_DATASHEET)

  constructor(
    private _pepService: PepService,
    private _permissionService: PermissionService,
    private _snackbarService: SnackbarService
  ) { }

  deleteDatasheetSection(): void {
    this._pepService.deleteDatasheetSession(this.sessionId)
      .pipe(
        take(1),
        catchError(error => {
          this._snackbarService.showError('Falha ao apagar seção da ficha, por favor tente novamente mais tarde.')
          return of(null)
        })
      )
      .subscribe((sectionId: number) => {
        if (sectionId) {
          this.sessionDeleted.next()
          this._snackbarService.show('Seção da ficha de atendimento apagada.')
        }
      })
  }
}